import PreviewForm from "./partials/preview-form";
import { Route } from "react-router-dom";
import { ROUTES } from "@/routes_new";
import SearchSubmit from "./submit";

export default function SearchPreview() {
  return (
    <>
      <div className="p-4 lg:p-6 max-w-(--site-content-max-width)">
        <PreviewForm />
      </div>

      <Route path={ROUTES.SEARCH_SUBMIT_ORGID} component={SearchSubmit} />
    </>
  );
}
